import { SignalDispatcher } from 'ste-signals';

export const contactEvents = {
  newContactCreated: new SignalDispatcher(),
};
